// src/components/Login.jsx (actualizado con localStorage)
import React, { useState } from 'react';

const Login = ({ onLogin, onBack }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Usuarios autorizados
  const authorizedUsers = {
    'alan@packsys.com': {
      password: 'alanpacksys123$',
      name: 'Alan',
    },
    'supervisor13@packsys.com': {
      password: 'chrispacksys123$',
      name: 'Chris',
    },
    'eugenio@packsys.com': {
      password: 'eugeniopacksys123$',
      name: 'Eugenio',
    },
    'sup.plataformas@packsys.com': {
      password: 'isapacksys123$',
      name: 'Isa',
    },
    'paty@packsys.com': {
      password: 'patypacksys123$',
      name: 'Paty',
    },
    'monse@packsys.com': {
      password: 'monsepacksys123$',
      name: 'Monse',
    },
    'alex@packsys.com': {
      password: 'alexpacksys123$',
      name: 'Alex',
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Simular verificación
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const user = authorizedUsers[email];

      if (user && user.password === password) {
        // Login exitoso
        const userData = {
          email,
          name: name.trim() || user.name, // Usar el nombre ingresado o el predeterminado
          timestamp: new Date().toISOString(),
        };

        // Guardar en localStorage
        localStorage.setItem('packsys_auth', JSON.stringify(userData));
        onLogin(userData);
      } else {
        setError('Credenciales incorrectas. Solo usuarios autorizados.');
      }
    } catch (err) {
      setError('Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 flex items-center justify-center px-4 py-8 relative overflow-hidden">
      {/* Background igual que Coming Soon */}
      <div className="absolute inset-0 bg-[url('https://cdn.shopify.com/s/files/1/0399/8685/6102/files/DSC_08961.jpg?v=1697039409')] bg-center bg-cover bg-no-repeat opacity-20"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-blue-800/50 to-purple-900/50"></div>

      <div className="w-full max-w-md mx-auto relative z-10">
        {/* Card de Login */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border-2 border-white/20 shadow-2xl">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-white/10 backdrop-blur-lg rounded-2xl border-2 border-white/20 flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl text-white font-bold">🔒</span>
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">
              Acceso Exclusivo
            </h1>
            <p className="text-gray-200 text-sm">
              Solo para usuarios autorizados
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white/95 text-slate-800 border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-packsys-orange focus:border-transparent"
                placeholder="usuario@packsys.com"
                required
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-white text-sm font-medium mb-2">
                Contraseña
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-white/95 text-slate-800 border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-packsys-orange focus:border-transparent"
                placeholder="••••••••"
                required
                disabled={loading}
              />
            </div>

            {error && (
              <div className="bg-red-500/20 border border-red-400/30 rounded-xl p-3">
                <p className="text-red-200 text-sm text-center">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-packsys-orange to-orange-500 text-white py-3 px-4 rounded-xl font-semibold hover:from-orange-500 hover:to-orange-600 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                  Verificando...
                </div>
              ) : (
                'Iniciar Sesión'
              )}
            </button>
          </form>

          {/* Back to Coming Soon */}
          <div className="text-center mt-6">
            <button
              onClick={onBack}
              className="text-gray-300 hover:text-white text-sm transition-colors duration-300"
            >
              ← Volver al sitio principal
            </button>
          </div>

          {/* Info para testers */}
          <div className="mt-6 p-4 bg-blue-500/20 rounded-xl border border-blue-400/30">
            <p className="text-blue-200 text-xs text-center">
              💡 Acceso exclusivo para equipo de testing
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
